import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslationService } from '../../services/translation.service';
import type { FollowUpTranslations } from '../../i18n/follow-up';
import en from '../../i18n/en/follow-up';

@Component({
  selector: 'app-follow-up',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './follow-up.component.html',
  styleUrl: './follow-up.component.css',
})
export class FollowUpComponent {
  @Input() applicationId!: number;
  @Input() jobTitle?: string;
  @Input() companyName?: string;
  @Output() submitFollowUp = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  followUpForm: FormGroup;
  types = [
    { label: 'Email', value: 'email' },
    { label: 'Call', value: 'call' },
    { label: 'LinkedIn', value: 'linkedin' },
    { label: 'Other', value: 'other' },
  ];

  translations: FollowUpTranslations = en as FollowUpTranslations;

  get t(): FollowUpTranslations {
    return this.translations;
  }

  constructor(private fb: FormBuilder, private translationService: TranslationService) {
    this.followUpForm = this.fb.group({
      type: ['', Validators.required],
      note: [''],
    });

    const current = this.translationService.getFollowUpTranslations();
    if (current) {
      this.translations = current;
    }
    this.updateTypes();

    this.translationService.onChange(() => {
      const next = this.translationService.getFollowUpTranslations();
      if (next) {
        this.translations = next;
        this.updateTypes();
      }
    });
  }

  private updateTypes(): void {
    this.types = [
      { label: this.t.TYPE_EMAIL, value: 'email' },
      { label: this.t.TYPE_CALL, value: 'call' },
      { label: this.t.TYPE_LINKEDIN, value: 'linkedin' },
      { label: this.t.TYPE_OTHER, value: 'other' },
    ];
  }

  onSubmit() {
    if (this.followUpForm.valid) {
      this.submitFollowUp.emit({
        ...this.followUpForm.value,
        application_id: this.applicationId,
      });
    } else {
      this.followUpForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
